<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="loader">
    <div class="loader-spinner" :class="size === 's' && 'small'" />
    <div v-if="text" class="loader-text" :class="size === 's' && 'small'">{{ text }}</div>
  </div>
</template>

<script>
/**
 * Display diferent icon logo depending on type
 * @example [none]
 */
export default {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: 'n'
    },
    text: {
      type: String,
    },
  },
}
</script>

<style lang="stylus" scoped>
.loader
  position: absolute
  top: 50%
  left: 50%
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  transform: translate(-50%, -50%)
  gap: vw(20px)

.loader-spinner
  display: grid
  width: 56px
  height: 56px

  &:before,
  &:after
    background: var(--c) 50% 0, var(--c) 50% 100%, var(--c) 100% 50%, var(--c) 0 50%
    background-size: 13.4px 13.4px
    background-repeat: no-repeat
    content: ""
    animation: spinner-3hs4a3 1s infinite
    grid-area: 1 / 1

  &:before
    margin: 4.5px
    background-size: 9px 9px
    animation-timing-function: linear
    --c: radial-gradient(farthest-side, $corporate_color 92%, #0000)

  &:after
    --c: radial-gradient(farthest-side, $corporate_color 92%, #0000)
    
  &.small
    display: none

.loader-text
  m-font-size(24, 28)
  
  &.small
    m-font-size(18, 22)

@keyframes spinner-3hs4a3
  100%
    transform: rotate(0.5turn)
</style>
